import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { MiscApi } from '@shared/api/rest';
import { GetContactsResponse } from '@shared/api/rest/misc';
import { RequestStrategyEnum } from '@shared/api/rest/models';

interface ContactsType {
  data: GetContactsResponse | null;
  loading: boolean;
  error: string | null;
  get: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useGetContactsStore = create<ContactsType>((set) => ({
  data: null,
  loading: false,
  error: null,

  get: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null, data: null });
      const result = await MiscApi.getContacts(signal);
      set({ data: result?.data ?? [], loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
      throw error;
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: null, loading: false, error: null }),
}));
